import { memo } from 'react';
import {
  PhoneIcon,
  SMSIcon,
  SmartphoneIcon,
  LandlineIcon,
  VOIPIcon,
} from '@rsos/assets/icons';
import { SOURCE_SMS } from '@rsos/components';
import {
  VOIP,
  PHASE,
  TEXT,
  ALI_UNDERSCORE,
} from '@rsos/constants/locationTypes';
import { getMostRecentLoc } from '@rsos/utils/getMostRecentLoc';
import {
  ResultWrapper,
  PhoneNumber,
  IconWrapper,
} from '../ConnectedUniversalSearch.styles';

const resolveCallIcon = (mostRecentLoc, isPremiumUser) => {
  const applicationType = mostRecentLoc.application;
  const classOfService = mostRecentLoc.class_of_service_category;
  const isAniAli = applicationType?.startsWith(ALI_UNDERSCORE);

  if (classOfService === TEXT) return <SMSIcon width={16} height={16} />;
  if (isPremiumUser) {
    if (
      isAniAli &&
      ((classOfService && !classOfService?.startsWith(PHASE)) ||
        !classOfService)
    ) {
      if (classOfService === VOIP) {
        return (
          <VOIPIcon
            width={16}
            height={16}
            viewboxWidth={16}
            viewboxHeight={16}
          />
        );
      }
      return <LandlineIcon width={16} height={16} />;
    }
    return <SmartphoneIcon width={16} height={16} />;
  }
  return (
    <IconWrapper mr="6px">
      <PhoneIcon width={10} height={16} />
    </IconWrapper>
  );
};
const StyledCall = memo(
  ({
    call,
    index,
    mouseCursor,
    isPremiumUser,
    formatPhoneNumber,
    handleSearchResult,
    maxWidth,
  }) => {
    const mostRecentLocRecord = getMostRecentLoc(call);
    const { source, caller_id: callerID } = mostRecentLocRecord;
    const isTextType =
      source === SOURCE_SMS ||
      mostRecentLocRecord.class_of_service_category === TEXT;
    return (
      <ResultWrapper
        key={index}
        onClick={() => handleSearchResult(callerID)}
        isHovered={mouseCursor === index}
        maxWidth={maxWidth}
      >
        <>
          {isTextType ? (
            <SMSIcon width={16} height={16} />
          ) : (
            resolveCallIcon(mostRecentLocRecord, isPremiumUser)
          )}
          <PhoneNumber>{formatPhoneNumber(callerID)}</PhoneNumber>
        </>
      </ResultWrapper>
    );
  },
);
export default StyledCall;
